export default __webpack_public_path__ + "img/settings.35fa5adb.svg";